import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from '../../../../components/CiscoUi';

export function TopologiesPublishedLabel(): ReactElement {
  const { t } = useTranslation();

  return (
    <Label colour="warning-alt" size="small">
      {t('common.demoPublished')}
    </Label>
  );
}
